import { observer } from 'mobx-react-lite';

import type { AlertsManagerWidgetState } from '../AlertsManagerWidgetState';
import { ManualAnomaliesTable } from '../manual-anomalies/ManualAnomaliesTable';
import type { ManualAnomaliesViewController, ViewStore } from '../stores/ViewStore';

type Props = {
  viewStore: ViewStore;
  controller: ManualAnomaliesViewController;
  widgetState: AlertsManagerWidgetState;
};

export const ManualAnomaliesView = observer(function ManualAnomaliesView({
  viewStore,
  controller,
  widgetState,
}: Props) {
  return <ManualAnomaliesTable viewStore={viewStore} service={controller.service} widgetState={widgetState} />;
});
